<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">{{ blipName }} 아티스트 이름설정</h4>
        </template>
        <button @click="addNameForm" type="button" class="btn btn-success">+</button>
        <div class="row" v-for="(item, index) in names">
          <label class="col-sm-2 col-form-label">언어</label>
          <el-select class="select-primary col-sm-3" size="large" placeholder="선택" v-model="item.code">
            <el-option v-for="option in codes" class="select-primary" :value="option.code" :label="option.name" :key="option.name" />
          </el-select>
          <label class="col-sm-2 col-form-label">이름</label>
          <div class="col-sm-3">
            <base-input placeholder="" v-model="item.name">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <button @click="removeNameForm(index)" type="button" class="btn btn-danger">-</button>
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import * as _ from "lodash";

export default {
  components: {
    Card,
    BaseInput,
  },
  async created() {
    if (!this.$route.query.unitId || !this.$route.query.memberId) {
      Toast.error("잘못된접근입니다");
      history.go(-1);
      return;
    }
    if (this.$route.query.blipName) {
      this.blipName = this.$route.query.blipName;
    }
    this.unitId = this.$route.query.unitId;
    this.memberId = this.$route.query.memberId;
    await this.getLanguageCodes();
    await this.getData();
  },
  data() {
    return {
      blipName: null,
      unitId: null,
      memberId: null,
      codes: [],
      names: [],
    };
  },
  methods: {
    async getLanguageCodes() {
      return this.$axios.get(`/common/languageCodes`).then((res) => {
        this.codes = res.data.data;
      });
    },
    addNameForm() {
      this.names.push({ code: null, name: null });
    },
    removeNameForm(index) {
      this.names.splice(index, 1);
    },
    async getData() {
      return this.$axios.get(`/artistUnit/${this.unitId}/members/${this.memberId}/names`).then((res) => {
        this.names = res.data.data;
      });
    },
    async onSubmit() {
      if (!this.unitId || !this.memberId) {
        Toast.error("잘못된 접근입니다.");
        return;
      }
      const selectedCodes = this.names.map((name) => name.code);
      if (this.hasDuplicates(selectedCodes)) {
        Toast.error("중복된언어가 존재합니다");
        return;
      }
      const param = {
        names: this.names,
      };
      return this.$axios
        .put(`/artistUnit/${this.unitId}/members/${this.memberId}/names`, {
          params: param,
        })
        .then((res) => {
          Toast.success("등록되었습니다");
        });
    },
    goBack() {
      history.go(-1);
    },
    hasDuplicates(a) {
      return _.uniq(a).length !== a.length;
    },
  },
};
</script>
<style>
.bootstrap-switch {
  margin: 6px;
}
</style>
